export const AMPLITUDE_EVENT_NAMES = {
    viewed: "trade in banner exact valuation viewed"
};

export const TRADE_IN_GA_EVENTS = {
    viewed: {
        event: "custom_event",
        eventCategory: "Cars24_detail_page",
        eventAction: "viewed",
        eventLabel: "trade_in_banner_exact_valuation"
    }

};
